export const Baseurl = "https://api.mcollect.co.in";
export const Imageurl = "https://imageapi.mcollect.co.in";
// export const Baseurl = "http://localhost:4042";
export const mapApiKey="AIzaSyD9On5PRHixcY4UO4T-0DowNTcDyBhMrlI"

